import { render, staticRenderFns } from "./CopyCommentContentSelect.vue?vue&type=template&id=538efbc6&"
import script from "./CopyCommentContentSelect.vue?vue&type=script&lang=js&"
export * from "./CopyCommentContentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('538efbc6')) {
      api.createRecord('538efbc6', component.options)
    } else {
      api.reload('538efbc6', component.options)
    }
    module.hot.accept("./CopyCommentContentSelect.vue?vue&type=template&id=538efbc6&", function () {
      api.rerender('538efbc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/contents/medicaltrend-manage/CopyCommentContentSelect.vue"
export default component.exports